// extracted by mini-css-extract-plugin
module.exports = {"noBorderRadius":"ArticlesDetails_noBorderRadius__NDwdY","Trigger":"ArticlesDetails_Trigger__hKPst"};